import React from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Form } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import parse from 'html-react-parser';
import Img from 'gatsby-image';
import GenerateLink from "../common/site/generate-link"

import { useWindowSize } from '../../hooks/winodw-size'
import "./ServiceContentOne.scss"
const ServiceContentOne = (props) => {
    const [ windowWidth ] = useWindowSize();
    return (
        <React.Fragment>
            <section className="about-area components--AreaGuideDetails--About--About">
                <Container>
                        <Row>
                            <div className="row-box flex-lg-row-reverse">
                            <Col md="12" lg="6" className="pe-lg-0">
                            <ScrollAnimation animateIn="fadeInUp" animateOnce>
                                <div className="img-zoom about-block-img">
                                    {props.Image &&
                                        <Img fluid={props.Image.url_sharp.childImageSharp.fluid} alt={props.Image.alternativeText} />
                                    }
                                </div>

                      </ScrollAnimation>
                            </Col>
                            <Col md="12" lg="6">
                            <ScrollAnimation animateIn="fadeInUp" animateOnce>
                                <div className="about-content">
                                    <span className="sub-title">{props.Title}</span>
                                    {parse(props.Content)}
                                    {props.CTA_Label &&
                                    <GenerateLink link={props.CTA_Link} class="btn d-flex align-items-center">{props.CTA_Label}
                                    <i className="icon-arrow"></i>
                                    </GenerateLink>
                                    }
                              
                                </div>
                                </ScrollAnimation>    
                            </Col>
                            </div>
                        </Row>
  
                        
                    </Container>
                
            </section>
        </React.Fragment>
    )
}
export default ServiceContentOne
